import * as _4 from 'lodash4';
import { ISection, ICourse } from '../../interfaces/scheduler_interfaces';
import { SectionSwapModel } from '../models/course_section_swap_model';
import { ITermCoursesDatasource } from '../../views/term_courses/datasources/term_courses_datasource';
import { TermCourseServant } from '../../views/term_courses/servants/term_course_servant';
export class SectionSwapServant {
  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private appConfigModel: any
  ) {}

  isSwapFeatureEnabled() {
    return this.appConfigModel.model.member_features['reg-section_swap'];
  }

  isPermissionPinsFeatureEnabled() {
    return this.appConfigModel.model.member_features['reg-class_permission'];
  }
  isInSwapMode() {
    return _4.includes(this.$state.current.name || '', 'swap');
  }
  isInSwapCourseMode() {
    return this.isInSwapMode() && _4.isEqual(_4.get(this.$stateParams, 'swapCourse'), 'true');
  }

  isInSectionTypeListUrl() {
    return _4.includes(this.$state.current.name || '', 'sectionTypeList');
  }

  isInCourseSectionsUrl() {
    return _4.includes(this.$state.current.name || '', 'courseSections');
  }

  isInCourseListUrl(currentStateName: string = '') {
    return currentStateName === 'my.schedule.registration.swap';
  }

  isPreviousStateSectionTypeList() {
    return _4.includes(_4.get(this.$state, '__previousRoute__.state.name') || '', 'sectionTypeList');
  }

  sectionSwapType(section: ISection) {
    const FROM_VALUE = 'from';
    const TO_VALUE = 'to';

    if (_4.find(this.ngCourseSectionSwapModel.read().swap_from_section_ids, { id: section.id })) {
      return FROM_VALUE;
    }
    if (_4.find(this.ngCourseSectionSwapModel.read().swap_to_section_ids, { id: section.id })) {
      return TO_VALUE;
    }
    return '';
  }

  gotoSwapSectionMode(section: ISection) {
    const course = _4.find(this.ngTermCoursesDatasource.read(), { id: section.course });

    if (TermCourseServant.isMultiSectionCourse(course)) {
      this.$state.go(`my.schedule.registration.swap.sectionTypeList`, {
        courseId: section.course,
        sectionTypeId: section.section_type,
        ignoreConflicts: true,
        swapCourse: false
      });
    } else {
      this.$state.go(`my.schedule.registration.swap.courseSections`, {
        courseId: section.course,
        sectionTypeId: section.section_type,
        ignoreConflicts: true,
        swapCourse: false
      });
    }
  }

  gotoSwapCourseMode(course: ICourse) {
    this.$state.go(`my.schedule.registration.swap`, {
      courseId: course.id,
      ignoreConflicts: true,
      swapCourse: true
    });
  }

  showSwapBackButton(swapCourse: string): boolean {
    let showButton = true;
    if (swapCourse === 'true' && this.isInCourseListUrl(this.$state.current.name)) {
      showButton = false;
    } else if (swapCourse === 'false') {
      showButton = false;
      if (this.isPreviousStateSectionTypeList()) {
        showButton = true;
      }
    }
    return showButton;
  }

  getPreviousSwapState(swapCourse: string): string {
    let backState = '';
    const swappingCourse = swapCourse === 'true';
    const swapRoot = 'my.schedule.registration.swap';
    if (swappingCourse) {
      if (this.isInCourseSectionsUrl() && !this.isPreviousStateSectionTypeList()) {
        backState = swapRoot;
      }
      if (this.isInCourseSectionsUrl() && this.isPreviousStateSectionTypeList()) {
        backState = `${swapRoot}.sectionTypeList`;
      }
      if (this.isInSectionTypeListUrl()) {
        backState = swapRoot;
      }
    } else {
      if (this.isInCourseSectionsUrl()) {
        backState = `${swapRoot}.sectionTypeList`;
      }
    }
    return backState;
  }

  getSwapFromIds(model: SectionSwapModel) {
    return _4.compact(_4.map(model.read().swap_from_section_ids, (item) => item.id));
  }

  getSwapToIds(model: SectionSwapModel) {
    return _4.compact(_4.map(model.read().swap_to_section_ids, (item) => item.id));
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/servants/section_swap_servant.ts